(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxSearchPageCustomForm', {
		bindings: {
			view: '<',
			parameters: '<',
		},
		controller: MxSearchPageCustomFormCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-content-widget-view/list/mx-search-page-custom-form.html',
	});

	MxSearchPageCustomFormCtrl.$inject = ['$rootScope', '$element', '$compile', '$scope', '$stateParams', 'mx.shell.EventService', 'mx.shell.SearchProviderService'];

	function MxSearchPageCustomFormCtrl($rootScope, $element, $compile, $scope, $stateParams, eventService, searchService) {
		var vm = this,
			localScope;

		vm.$onInit = function () {
			if (vm.view) {
				compile(vm.view);
			}
			var currentSearch = searchService.currentSearch();
			var keyword = currentSearch.uiToken === vm.parameters.uiToken ? currentSearch.keyword : '';

			vm.formActive =
				(!vm.parameters.filterType || ((vm.parameters.filterType === 'structure' || vm.parameters.filterType === 'nofilter') && !vm.parameters.filterId)) && !keyword;
		};

		vm.$postLink = function () {
			window.setTimeout(function () {
				vm.customFormButton = $element.find('.mx-search-page-custom-form--button');
				angular.element('.mx-search-page--toolbar').prepend(vm.customFormButton);
			}, 100);
		};
		vm.$onDestroy = function () {
			vm.customFormButton?.remove();
		};

		vm.toggle = function () {
			vm.formActive = !vm.formActive;
			eventService.dispatchEvent(mx.shell.EventCodes.LayoutChanged, 'ConfigurationFormSwitched');
		};

		eventService.subscribeTo(
			mx.shell.EventCodes.Search,
			function (e, searchOptions) {
				searchOptions = searchOptions || {};
				if (vm.parameters.uiToken !== searchOptions.uiToken) {
					return;
				}
				if (searchOptions.dontHideCustomForm !== true) {
					vm.formActive = false;
				}
			},
			$scope
		);

		return vm;

		function compile(tpl) {
			destroy();
			localScope = $rootScope.$new(false, $scope);
			localScope.vm = vm.parameters;

			var formElement = $element.find('.mx-search-page-custom-form--body');
			var literalElement = $element.find('.mx-search-page-custom-form--literal');

			var rootContainer = $(tpl)[0];
			var formTpl = rootContainer.firstChild.children[0];
			var literalTpl = rootContainer.firstChild.children[1];

			var _elemForm = angular.element(formTpl);
			var _elemLiteral = angular.element(literalTpl);

			formElement.append(_elemForm);
			literalElement.append(_elemLiteral);

			$compile(_elemForm)(localScope);
			$compile(_elemLiteral)(localScope);
			$element.on('$destroy', destroy);

			function destroy() {
				if (localScope) {
					localScope.$destroy();
					formElement.empty();
					literalElement.empty();
					localScope = null;
				}
			}
		}
	}
})();
